"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Invitees_1 = __importDefault(require("./Invitees"));
class Index {
    constructor(parent, sessionId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.sessionId = sessionId;
    }
    path(withParameter = true) {
        if (withParameter && this.sessionId !== null) {
            return `${this.parent.path()}/sessions/${this.sessionId}`;
        }
        return `${this.parent.path()}/sessions`;
    }
    /**
     * Creates a new Session for a given Webinar
     * HTTP Method: post
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */
    async post(wcsSessionBaseModel, restRequestConfig) {
        const r = await this.rc.post(this.path(false), wcsSessionBaseModel, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a Webinar Session by ID.
     * HTTP Method: get
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: ReadWebinars
     */
    async get(restRequestConfig) {
        if (this.sessionId === null) {
            throw new Error('sessionId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a Webinar Session. All child objects (Invitees) will be also deleted.
   * It is disallowed to delete a Session which is in 'Active' or 'Finished' state
   *
     * HTTP Method: delete
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */
    async delete(restRequestConfig) {
        if (this.sessionId === null) {
            throw new Error('sessionId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates a Webinar Session. The payload may contain certain attributes from the Session resource
   * (it is a partial update). Changing the 'status' field usually invokes certain workflow actions.
   * Updating a Session in 'Active' or 'Finished' status is prohibited.
   * Some status transitions (for example, to 'Active" or 'Finished') may be prohibited.
   *
     * HTTP Method: patch
     * Endpoint: /webinar/configuration/v1/webinars/{webinarId}/sessions/{sessionId}
     * Rate Limit Group: Heavy
     * App Permission: EditWebinars
     */
    async patch(wcsSessionBaseModel, restRequestConfig) {
        if (this.sessionId === null) {
            throw new Error('sessionId must be specified.');
        }
        const r = await this.rc.patch(this.path(), wcsSessionBaseModel, undefined, restRequestConfig);
        return r.data;
    }
    invitees(inviteeId = null) {
        return new Invitees_1.default(this, inviteeId);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map